<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div>
    <fieldset>
      <legend>
        {{ $t('Select your business entity type') }}
      </legend>

      <AuBusinessEntityTypeRadioGroup v-model="businessEntityType" name="entity_type" />
    </fieldset>

    <fieldset v-if="hasSelectedValidBusinessEntityType">
      <legend>
        {{ $t('Add your business details') }}
      </legend>

      <AuBusinessEntityDetailsForm
        v-model:business-entity="internalBusinessEntity"
        :compliance-data="complianceData"
      />
    </fieldset>

    <SubmitButton :text="$t('Save')" auto-submit class="m-t-20" />
  </div>
</template>

<script>
import { computed, ref } from 'vue'

import SubmitButton from '@/components/SubmitButton.vue'
import AuBusinessEntityDetailsForm from '@/components/compliances/BusinessEntity/Au/AuBusinessEntityDetailsForm.vue'
import AuBusinessEntityTypeRadioGroup from '@/components/compliances/BusinessEntity/Au/AuBusinessEntityTypeRadioGroup.vue'

export default {
  name: 'FreelancerAuBusinessEntityForm',

  components: {
    AuBusinessEntityDetailsForm,
    AuBusinessEntityTypeRadioGroup,
    SubmitButton,
  },

  props: {
    businessEntity: {
      type: Object,
      required: true,
    },

    complianceData: {
      type: Object,
      required: true,
    },
  },

  emits: ['update:businessEntity'],

  setup(props, { emit }) {
    const internalBusinessEntity = ref(props.businessEntity)

    const businessEntityType = computed({
      get() {
        return internalBusinessEntity.value.entityType
      },

      set(value) {
        internalBusinessEntity.value.entityType = value
        emit('update:businessEntity', this.internalBusinessEntity)
      },
    })

    const hasSelectedValidBusinessEntityType = computed(() =>
      ['au_limited', 'au_sole_trader'].includes(businessEntityType.value),
    )

    return {
      businessEntityType,
      hasSelectedValidBusinessEntityType,
      internalBusinessEntity,
    }
  },
}
</script>
